import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { IPreviewFeature } from 'src/app/services/app-initializer/app-initializer.service';
import { BaseComponent } from '../base.component';
import { FeatureService } from './preview-feature.service';

@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
    selector: 'app-preview-feature',
    templateUrl: './preview-feature.component.html',
    styleUrls: ['./preview-feature.component.scss']
})
export class PreviewFeatureComponent extends BaseComponent implements OnInit {
    form: UntypedFormGroup;
    previews: IPreviewFeature[];
    shownPreviews: IPreviewFeature[];

    constructor(public service: FeatureService, private fBuilder: UntypedFormBuilder) {
        super();
    }

    ngOnInit(): void {
        this.previews = this.service.snapshot.selectedPreviews;
        this.shownPreviews = (this.previews || []).filter(item => item.visible && item.inScope);
        this.form = this.createForm();
    }

    createForm() {
        const result = this.fBuilder.group({});
        const shownPreviewsGroup = this.fBuilder.group({});
        this.shownPreviews.forEach(preview => {

            let disable = preview.enabled == false;
            shownPreviewsGroup.addControl(preview.id, this.fBuilder.control({ value: preview.active, disabled: disable }));
        });

        result.addControl('show', shownPreviewsGroup);

        this.subscriptions.push(result.valueChanges.subscribe(values => {
            this.setValues({ ...values.show, ...values.disabled, ...values.hide });
        }));

        return result;
    }

    setValues(values: any) {
        const ids = Object.getOwnPropertyNames(values);

        const newPreviews = ids.map(id => ({ ...this.previews.find(preview => preview.id === id), active: values[id] } as IPreviewFeature));

        newPreviews.forEach(preview => {
            this.service.setPreviewItem(preview);
        })
    }

}
